import React from "react";
import {Image} from "@arctheme-components/elements/Image/Image";
import {SearchTileBadge} from "./SearchTileBadge";

export const SearchBlogArticleTile = ({ article }) => {
    const tags = article.meta.map(tag => tag.split('|'));
    return (
        <div className={'blog-article-tile flex flex-col pb-2 lg:pb-3'}>
            <div className="blog-article-tile__image-wrapper">
                <Image imageUrl={article.image} classes={'blog-article-tile__image'} />
                {tags && <SearchTileBadge badges={tags} />}
            </div>
            <div className={"blog-article-tile-heading h6"}>  {article.title} </div>
        </div>
    )
}

export default SearchBlogArticleTile;
